export default __webpack_public_path__ + "static/media/NLx_Research_Hub.affec5bc.png";